import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { ProductOverview } from './components/ProductOverview';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { MoreTestimonials } from './components/MoreTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-gray-900 font-sans selection:bg-brand-accent/30 selection:text-gray-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <TomosSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <ComparisonTable data-id="element-9" />
      <MoreTestimonials data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <CostOfInaction data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}